module.exports = __webpack_public_path__ + "img/ico-file-document-outline-grey.52fb2004.svg";